import {computed, inject, Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {ServerAddress} from '../../models/server-address.model';
import {Notification} from '../../bfa-api/models/notification';
import {AuthQuery} from '../../queries/auth.query';
import {ServerSelectionService} from '../server-selection/server-selection.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private readonly authQuery = inject(AuthQuery);
    private readonly serverSelectionService = inject(ServerSelectionService);
    private readonly hasReadNotificationInSession: WritableSignal<boolean>;
    private readonly selectedServer: Signal<ServerAddress | undefined>;
    private readonly currentNotification: Signal<Notification | undefined>;

    public constructor() {
        this.hasReadNotificationInSession = signal(false);

        this.selectedServer = this.serverSelectionService.getSelectedServerSignal();
        this.currentNotification = computed(() => {
            return this.selectedServer()?.serverInformation?.notification;
        });
    }

    public getCurrentNotificationSignal(): Signal<Notification | undefined> {
        return this.currentNotification;
    }

    public getShowNotificationSignal(): Signal<boolean> {
        return computed(() => {
            return !(!this.currentNotification() || this.selectedServer()
                ?.notificationReadByUserIds
                ?.includes(this.authQuery.getUserId()) || this.hasReadNotificationInSession());
        });
    }

    public setHasReadNotificationInSession(hasReadNotificationInSession: boolean): void {
        this.hasReadNotificationInSession.set(hasReadNotificationInSession);
    }

    public markNotificationAsRead(): void {
        const selectedServer = this.selectedServer();
        if (selectedServer) {
            const updatedServerAddress = structuredClone(selectedServer);

            updatedServerAddress.notificationReadByUserIds = [
                ...selectedServer.notificationReadByUserIds,
                this.authQuery.getUserId()
            ];

            this.serverSelectionService.updateServerAddresses(this.serverSelectionService.getServerAddresses()
                .map((server) => server.selected ? updatedServerAddress : server));
        }
    }
}
